<template>
  <div class="show_all_content_wrapper">
    <!-- Start:: Main Section -->
    <main>
      <!--  =========== Start:: Filter Form =========== -->
      <div
        class="filter_content_wrapper"
        :class="{ active: filterFormIsActive }"
      >
        <button
          class="filter_toggler"
          @click="filterFormIsActive = !filterFormIsActive"
        >
          <i class="fal fa-times"></i>
        </button>
        <div class="filter_title_wrapper">
          <h5>{{ $t("TITLES.searchBy") }}</h5>
        </div>

        <div class="filter_form_wrapper">
          <form @submit.prevent="submitFilterForm">
            <div class="row justify-content-center align-items-center w-100">
              <!-- Start:: Ad Number Input -->

              <!-- End:: Ad Number Input -->

              <!-- Start:: Ad Name Input -->
              <base-input
                col="6"
                type="text"
                :placeholder="$t('PLACEHOLDERS.ad_name')"
                v-model.trim="filterOptions.ad_name"
              />
              <!-- End:: Ad Name Input -->

              <!-- Start:: Advertiser Name Input -->
              <base-input
                col="6"
                type="text"
                :placeholder="$t('PLACEHOLDERS.advertiser_name')"
                v-model.trim="filterOptions.advertiser_name"
              />
              <!-- End:: Advertiser Name Input -->
            </div>

            <div class="btns_wrapper">
              <a-tooltip placement="bottom">
                <template slot="title">
                  <span>{{ $t("BUTTONS.search") }}</span>
                </template>
                <span
                  class="submit_btn"
                  @click="submitFilterForm"
                  :disabled="isWaitingRequest"
                >
                  <i class="fal fa-search"></i>
                </span>
              </a-tooltip>

              <a-tooltip placement="bottom">
                <template slot="title">
                  <span>{{ $t("BUTTONS.rseet_search") }}</span>
                </template>
                <span
                  class="reset_btn"
                  :disabled="isWaitingRequest"
                  @click="resetFilter"
                >
                  <i class="fal fa-redo"></i>
                </span>
              </a-tooltip>
            </div>
          </form>
        </div>
      </div>
      <!--  =========== End:: Filter Form =========== -->

      <!--  =========== Start:: Table Title =========== -->
      <div class="table_title_wrapper">
        <div class="title_text_wrapper">
          <h5>{{ $t("PLACEHOLDERS.manage_ad_complaints") }}</h5>
          <button
            v-if="!filterFormIsActive"
            class="filter_toggler"
            @click.stop="filterFormIsActive = !filterFormIsActive"
          >
            <i class="fal fa-search"></i>
          </button>
        </div>
      </div>
      <!--  =========== End:: Table Title =========== -->

      <div class="d-flex justify-content-end">
        <base-input
          :label="$t('TITLES.item_per_page')"
          :placeholder="$t('TITLES.item_per_page')"
          col="5"
          type="number"
          class="my-0 base-input py-0"
          v-model="paginations.items_per_page"
        />
      </div>

      <!--  =========== Start:: Data Table =========== -->

      <v-data-table
        class="thumb"
        :loading="loading"
        :loading-text="$t('TABLES.loadingData')"
        :search="searchValue"
        :headers="tableHeaders"
        :items="tableRows"
        item-class="ltr"
        :items-per-page="
          paginations.items_per_page === ''
            ? 10
            : Number(paginations.items_per_page)
        "
        hide-default-footer
      >
        <!-- Start:: No Data State -->
        <template v-slot:no-data>
          {{ $t("TABLES.noData") }}
        </template>
        <!-- End:: No Data State -->

        <!-- Start:: Serial Number -->
        <template v-slot:[`item.id`]="{ item, index }">
          <div class="table_image_wrapper">
            <h6 class="text-danger" v-if="!item?.id">
              {{ $t("TABLES.noData") }}
            </h6>
            <p v-else>
              {{
                (paginations.current_page - 1) * paginations.items_per_page +
                index +
                1
              }}
            </p>
          </div>
        </template>
        <!-- End:: Serial Number -->

        <!-- Start:: Ad Name (As Link) -->
        <template v-slot:[`item.ad_name`]="{ item }">
          <h6 class="text-danger" v-if="!item.name">
            {{ $t("TABLES.noData") }}
          </h6>
          <span
            v-else
            @click="goToAdDetails(item.id)"
            class="ad-link"
            style="color: #26a1d6; cursor: pointer; text-decoration: underline;"
          >
            {{ item.name }}
          </span>
        </template>
        <!-- End:: Ad Name -->

        <!-- Start:: Advertiser Name -->
        <template v-slot:[`item.advertiser_name`]="{ item }">
          <h6 class="text-danger" v-if="!item.advertiser?.name">
            {{ $t("TABLES.noData") }}
          </h6>
          <h6 v-else>{{ item.advertiser.name }}</h6>
        </template>
        <!-- End:: Advertiser Name -->

        <!-- Start:: Complaints Count -->
        <template v-slot:[`item.complaints_count`]="{ item }">
          <h6 class="text-danger" v-if="item.complaints_count === undefined">
            {{ $t("TABLES.noData") }}
          </h6>
          <span class="badge badge-warning" v-else>
            {{ item.complaints_count }}
          </span>
        </template>
        <!-- End:: Complaints Count -->

        <!-- Start:: Ad Status -->
        <template v-slot:[`item.ad_status`]="{ item }">
          <h6 class="text-danger" v-if="!item.trans_status">
            {{ $t("TABLES.noData") }}
          </h6>
          <h6 v-else>{{ item.trans_status }}</h6>
        </template>
        <!-- End:: Ad Status -->

        <!-- Start:: Advertiser Status -->
        <template v-slot:[`item.advertiser_status`]="{ item }">
          <span class="text-success text-h5" v-if="item.advertiser?.is_active">
            <i class="far fa-check"></i>
          </span>
          <span class="text-danger text-h5" v-else>
            <i class="far fa-times"></i>
          </span>
        </template>
        <!-- End:: Advertiser Status -->

        <!-- Start:: Actions -->
        <template v-slot:[`item.actions`]="{ item }">
          <div class="actions">
            <!-- Block/Publish Ad Button -->
            <a-tooltip placement="bottom" v-if="$can('ads activate', 'ads')">
              <template slot="title">
                <span>
                  <strong>{{ $t("PLACEHOLDERS.ad_name") }}:</strong>
                  {{
                    item.status === "blocked"
                      ? $t("BUTTONS.publish")
                      : $t("BUTTONS.block")
                  }}
                </span>
              </template>
              <button
                v-if="item.status === 'blocked'"
                class="btn_publish action-btn-with-label"
                @click="selectBlockAdItem(item)"
              >
                <i class="fad fa-bullhorn"></i>
                <span class="btn-label">{{ $t("BUTTONS.publish_ad") }}</span>
              </button>
              <button
                v-else
                class="btn_block action-btn-with-label"
                @click="selectBlockAdItem(item)"
              >
                <i class="fad fa-ban"></i>
                <span class="btn-label">{{ $t("BUTTONS.block_ad") }}</span>
              </button>
            </a-tooltip>

            <!-- Activate/Deactivate Advertiser Button -->
            <a-tooltip
              placement="bottom"
              v-if="$can('users activate', 'users') && item.advertiser"
            >
              <template slot="title">
                <span>
                  <strong>{{ $t("PLACEHOLDERS.advertiser_name") }}:</strong>
                  {{
                    item.advertiser.is_active
                      ? $t("BUTTONS.deactivate")
                      : $t("BUTTONS.activate")
                  }}
                </span>
              </template>
              <button
                v-if="!item.advertiser.is_active"
                class="btn_activate action-btn-with-label"
                @click="HandlingAdvertiserActivationStatus(item)"
              >
                <i class="fad fa-user-check"></i>
                <span class="btn-label">{{
                  $t("BUTTONS.activate_advertiser")
                }}</span>
              </button>
              <button
                v-else
                class="btn_deactivate action-btn-with-label"
                @click="selectDeactivateAdvertiserItem(item)"
              >
                <i class="fad fa-user-slash"></i>
                <span class="btn-label">{{
                  $t("BUTTONS.deactivate_advertiser")
                }}</span>
              </button>
            </a-tooltip>

            <!-- Show Button -->
            <a-tooltip placement="bottom">
              <template slot="title">
                <span>{{ $t("BUTTONS.show") }}</span>
              </template>
              <button class="btn_show" @click="showItem(item)">
                <i class="fal fa-eye"></i>
              </button>
            </a-tooltip>
          </div>
        </template>
        <!-- End:: Actions -->

        <!-- ======================== Start:: Dialogs ======================== -->
        <template v-slot:top>
          <!-- Start:: Block Ad Dialog -->
          <v-dialog @input="onBlockDialogToggle" v-model="dialogBlockAd">
            <v-card>
              <v-card-title class="text-h5 justify-center" v-if="itemToBlockAd">
                {{
                  itemToBlockAd.status === "blocked"
                    ? $t("PLACEHOLDERS.UnblockConfirmingMessage")
                    : $t("PLACEHOLDERS.BlockConfirmingMessage")
                }}
              </v-card-title>

              <form class="w-100" v-if="itemToBlockAd?.status !== 'blocked'">
                <base-input
                  col="12"
                  rows="3"
                  type="textarea"
                  :placeholder="$t('PLACEHOLDERS.blockReason')"
                  v-model.trim="blockReason"
                  required
                />
              </form>

              <v-card-actions>
                <v-btn
                  class="modal_confirm_btn"
                  @click="confirmBlockAd"
                  :disabled="
                    itemToBlockAd?.status !== 'blocked' &&
                    (!!!blockReason || blockReason?.length < 3)
                  "
                >
                  {{ $t("BUTTONS.ok") }}
                </v-btn>

                <v-btn class="modal_cancel_btn" @click="dialogBlockAd = false">
                  {{ $t("BUTTONS.cancel") }}
                </v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- End:: Block Ad Dialog -->

          <!-- Start:: Deactivate Advertiser Dialog -->
          <v-dialog v-model="dialogDeactivateAdvertiser">
            <v-card>
              <v-card-title
                class="text-h5 justify-center"
                v-if="itemToDeactivateAdvertiser"
              >
                {{
                  $t("TITLES.DeactivateConfirmingMessage", {
                    name: itemToDeactivateAdvertiser.advertiser.name,
                  })
                }}
              </v-card-title>

              <form class="w-100">
                <base-input
                  col="12"
                  rows="3"
                  type="textarea"
                  :placeholder="$t('PLACEHOLDERS.deactivateReason')"
                  v-model.trim="deactivateReason"
                  required
                />
              </form>

              <v-card-actions>
                <v-btn
                  class="modal_confirm_btn"
                  @click="HandlingAdvertiserActivationStatus"
                  :disabled="
                    !!!deactivateReason || deactivateReason?.length < 3
                  "
                >
                  {{ $t("BUTTONS.ok") }}
                </v-btn>

                <v-btn
                  class="modal_cancel_btn"
                  @click="dialogDeactivateAdvertiser = false"
                >
                  {{ $t("BUTTONS.cancel") }}
                </v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- End:: Deactivate Advertiser Dialog -->
        </template>
        <!-- ======================== End:: Dialogs ======================== -->
      </v-data-table>
      <!--  =========== End:: Data Table =========== -->
    </main>
    <!-- End:: Main Section -->

    <!-- Start:: Pagination -->
    <template>
      <div class="pagination_container text-center mt-3 mb-0">
        <v-pagination
          class="py-0"
          square
          v-model="paginations.current_page"
          :length="paginations.last_page"
          :total-visible="6"
          @input="updateRouterQueryParam($event)"
          :prev-icon="
            getAppLocale == 'ar' ? 'fal fa-angle-right' : 'fal fa-angle-left'
          "
          :next-icon="
            getAppLocale == 'ar' ? 'fal fa-angle-left' : 'fal fa-angle-right'
          "
        />
      </div>
    </template>
    <!-- End:: Pagination -->
  </div>
</template>

<script>
import { debounce } from "lodash";
import { mapGetters } from "vuex";

export default {
  name: "AllAdComplaints",

  computed: {
    ...mapGetters({
      getAppLocale: "AppLangModule/getAppLocale",
    }),
  },

  data() {
    return {
      // Start:: Loading Data
      loading: false,
      isWaitingRequest: false,
      // End:: Loading Data

      // Start:: Filter Data
      filterFormIsActive: false,
      filterOptions: {
        ad_id: null,
        ad_name: null,
        advertiser_name: null,
      },
      // End:: Filter Data

      // Start:: Table Data
      searchValue: "",
      tableHeaders: [
        {
          text: this.$t("TABLES.Reports.serialNumber"),
          value: "id",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("TABLES.Reports.adName"),
          value: "ad_name",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("TABLES.Reports.advertiserName"),
          value: "advertiser_name",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("TABLES.Reports.complaintsCount"),
          value: "complaints_count",
          align: "center",
          sortable: false,
        },

        {
          text: this.$t("TABLES.Reports.actions"),
          value: "actions",
          sortable: false,
          align: "center",
        },
      ],
      tableRows: [],
      // End:: Table Data

      // Start:: Dialogs Control Data
      dialogBlockAd: false,
      itemToBlockAd: null,
      blockReason: "",

      dialogDeactivateAdvertiser: false,
      itemToDeactivateAdvertiser: null,
      deactivateReason: "",
      // End:: Dialogs Control Data

      // Start:: Pagination Data
      paginations: {
        current_page: 1,
        last_page: 1,
        items_per_page: 10,
      },
      // End:: Pagination Data
    };
  },

  watch: {
    // Start:: Page Query Param Watcher To Get Page Data Based On It's Change
    ["$route.query.page"]() {
      this.paginations.current_page = +this.$route.query.page;
      this.setTableRows();
    },
    "paginations.items_per_page"(newVal, oldVal) {
      this.paginations.current_page = 1;
      this.debouncedFetch();
    },
    // End:: Page Query Param Watcher To Get Page Data Based On It's Change
  },

  methods: {
    debouncedFetch: debounce(function () {
      this.setTableRows();
    }, 500),

    // Start:: Handle Filter
    async submitFilterForm() {
      if (this.$route.query.page !== "1") {
        await this.$router.push({ path: "/reports/all", query: { page: 1 } });
      }
      this.setTableRows();
    },

    async resetFilter() {
      this.filterOptions.ad_id = null;
      this.filterOptions.ad_name = null;
      this.filterOptions.advertiser_name = null;

      if (this.$route.query.page !== "1") {
        await this.$router.push({ path: "/reports/all", query: { page: 1 } });
      }
      this.setTableRows();
    },
    // End:: Handle Filter

    // Start:: Set Table Rows
    updateRouterQueryParam(pagenationValue) {
      this.$router.push({
        query: {
          ...this.$route.query,
          page: pagenationValue,
        },
      });

      // Scroll To Screen's Top After Get Data
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    },

    async setTableRows() {
      this.loading = true;
      try {
        let res = await this.$axios({
          method: "GET",
          url: "ad-complaints",
          params: {
            page: this.paginations.current_page,
            id: this.filterOptions.ad_id,
            name: this.filterOptions.ad_name,
            user_name: this.filterOptions.advertiser_name,
            limit:
              this.paginations.items_per_page === ""
                ? 10
                : Number(this.paginations.items_per_page),
          },
        });

        this.loading = false;
        this.tableRows = res.data.data;
        this.paginations.last_page = res.data.meta.last_page;
      } catch (error) {
        this.loading = false;
        console.log(error.response?.data?.message);
      }
    },
    // End:: Set Table Rows

    goToAdDetails(adId) {
      this.$router.push({ path: `/advertisements/show/${adId}` });
    },
    // End:: Go To Ad Details

    // Start:: Show Complaint Details
    showItem(item) {
      this.$router.push({ path: `/reports/reports/${item?.id}` });
    },
    // End:: Show Complaint Details

    // ===== Start:: Block/Publish Ad =====
    onBlockDialogToggle() {
      this.blockReason = "";
    },

    selectBlockAdItem(item) {
      this.dialogBlockAd = true;
      this.itemToBlockAd = item;
    },

    async confirmBlockAd() {
      try {
        const REQUEST_DATA = new FormData();

        // Only send reason if blocking (not publishing)
        if (this.itemToBlockAd.status !== "blocked") {
          REQUEST_DATA.append("reason", this.blockReason ?? "");
        }

        await this.$axios({
          method: "POST",
          url: `ads/${
            this.itemToBlockAd.status === "blocked" ? "publish" : "block"
          }/${this.itemToBlockAd.id}`,
          data: REQUEST_DATA,
        });

        this.dialogBlockAd = false;
        this.blockReason = "";

        this.$message.success(
          this.itemToBlockAd.status === "blocked"
            ? this.$t("PLACEHOLDERS.publishedSuccessfully")
            : this.$t("PLACEHOLDERS.blockedSuccessfully")
        );

        this.setTableRows();
        this.itemToBlockAd = null;
      } catch (error) {
        this.dialogBlockAd = false;
        this.$message.error(error.response?.data?.message);
      }
    },
    // ===== End:: Block/Publish Ad =====

    // ===== Start:: Activate/Deactivate Advertiser =====
    selectDeactivateAdvertiserItem(item) {
      this.dialogDeactivateAdvertiser = true;
      this.itemToDeactivateAdvertiser = item;
    },

    async HandlingAdvertiserActivationStatus(selectedItem) {
      this.dialogDeactivateAdvertiser = false;

      let targetItem = this.itemToDeactivateAdvertiser
        ? this.itemToDeactivateAdvertiser
        : selectedItem;

      const REQUEST_DATA = new FormData();

      // If deactivating, send reason and set is_active to 0
      if (this.deactivateReason) {
        REQUEST_DATA.append("reason", this.deactivateReason);
        REQUEST_DATA.append("is_active", 0);
      } else {
        // If activating, set is_active to 1
        REQUEST_DATA.append("is_active", 1);
      }

      try {
        await this.$axios({
          method: "POST",
          url: `users/activate/${targetItem.advertiser.id}`,
          data: REQUEST_DATA,
        });

        this.$message.success(this.$t("MESSAGES.changeActivation"));
        this.setTableRows();
        this.itemToDeactivateAdvertiser = null;
        this.deactivateReason = null;
      } catch (error) {
        this.$message.error(error.response?.data?.message);
      }
    },
    // ===== End:: Activate/Deactivate Advertiser =====
  },

  created() {
    // Start:: Fire Methods
    window.addEventListener("click", () => {
      this.filterFormIsActive = false;
    });
    if (this.$route.query.page) {
      this.paginations.current_page = +this.$route.query.page;
    }
    this.setTableRows();
    // End:: Fire Methods
  },
};
</script>

<style scoped>
span.submit_btn {
  width: 45px;
  height: 45px;
  font-size: 16px;
  border-radius: 10px;
  color: var(--white_clr);
  transition: all 0.3s linear;
  background-color: #f6a513;
  display: flex;
  justify-content: center;
  align-items: center;
}

.ad-link:hover {
  color: #1a7aa8 !important;
}

.badge {
  padding: 5px 12px;
  border-radius: 12px;
  font-size: 13px;
  font-weight: 600;
}

.badge-warning {
  background-color: #ff9800;
  color: white;
}

/* Custom Button Styles for Different Actions */
.btn_publish {
  background-color: #4caf50 !important;
  color: white !important;
  border: none;
  padding: 8px 12px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
}

.btn_publish:hover {
  background-color: #45a049 !important;
  transform: scale(1.05);
}

.btn_block {
  background-color: #f44336 !important;
  color: white !important;
  border: none;
  padding: 8px 12px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
}

.btn_block:hover {
  background-color: #da190b !important;
  transform: scale(1.05);
}

.btn_activate {
  background-color: #2196f3 !important;
  color: white !important;
  border: none;
  padding: 8px 12px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
}

.btn_activate:hover {
  background-color: #0b7dda !important;
  transform: scale(1.05);
}

.btn_deactivate {
  background-color: #ff9800 !important;
  color: white !important;
  border: none;
  padding: 8px 12px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
}

.btn_deactivate:hover {
  background-color: #e68900 !important;
  transform: scale(1.05);
}

/* Buttons with labels */
.action-btn-with-label {
  width: auto !important;
  gap: 6px;
}

.action-btn-with-label .btn-label {
  font-size: 12px;
  font-weight: 600;
  color: #fff;
  white-space: nowrap;
}
</style>
